/**
 * Licensed Materials - Property of ROOTCLOUD
 * THIS MODULE IS "RESTRICTED MATERIALS OF ROOTCLOUD"
 * (c) Copyright ROOTCLOUD Inc. 2021 All Rights Reserved
 *
 * The source code for this program is not published or
 * otherwise divested of its trade secrets
 */
export default {
  title: {
    rootcloud: "树根互联",
    headerTitle: window.env.title.zh,
    logintTitle: "登录透明工厂运营平台",
    agree: "登录即表示您已同意根云平台",
    service: "服务协议",
    privacy: "隐私政策",
    and: "和",
    account: "账号",
    password: "密码",
    forgetPassword: "忘记密码?",
    codeLogin: "验证码登录",
    pleaseEnterAccount: "请输入账号",
    pleaseEnterThePassword: "请输入密码",
    pleaseEnteremailphoneNumber: "请输入您的用户名/邮箱/手机号",
    browserTitle: "资产管理系统",
  },
  route: {
    home: "首页",
    organization: "机构管理",
    asset: "资产管理",
    alarm: "故障管理",
    accountInfo: "资产详情",
    authority: "权限管理",
    account: "资产台账",
    dimension: "维度管理",
    dimensionInfo: "维度详情",
    relevanceInfo: "关联详情",
    createAsset: "创建资产",
    history: "工况历史",
    importLog: "批量导入日志",
    importLogInfo: "日志详情",
    accountType: "资产类型",
    userManage: "用户管理",
    roleManage: "角色管理",
    userCenter: "个人中心",
    userInfo: "个人信息",
    companyInfo: "企业信息",
    companyCenter: "企业中心",
    companyElectric: "能源价格",
    addEnergy: "添加能源",
    energyInfo: "能源详情",
    editEnergy: "编辑能源",
    expandField: "拓展字段",
    alarmDictionary: "故障字典",
    checkTime: "核算时间",
    basicManage: "基础管理",
    classesManage: "班制管理",
    searchClasses: "查询班制",
    classesDetail: "班制详情",
    alarmList: "报警清单",
    alarmCenter: "报警中心",
    sysManage: "系统管理",
    log: "日志查询",
    enterpriseMapMain: "企业运营",
    enterprise: "企业管理",
    enterpriseInfo: "企业详情",
    addEnterpriseApp: "应用授权",
    enterpriseMap: "企业分布",
    shelvesManage: "上架管理",
    goodsOnShelves: "硬件上架",
    appManagement: "应用上架",
    addApplication: "新增应用",
    editApplication: "编辑应用",
    applicationItem: "应用详情",
    projectWork: "项目实施",
    deliveryBatch: "发货批次",
    deliveryList: "发货清单",
    modelTemplate: "物模型模板库",
  },
  navbar: {
    languages: "选择语言",
    logOut: "退出",
    profile: "个人中心",
    permission: "权限管理",
  },
  sidebar: {
    goHome: "回首页",
  },
  login: {
    logIn: "登录",
    agree: "登录即表示您已同意根云平台",
    service: "服务协议",
    privacy: "隐私政策",
    and: "和",
    account: "账号",
    password: "密码",
    passwordLogin: "密码登录",
    forgetPassword: "忘记密码?",
    verificationCode: "验证码",
    getVerificationCode: "获取验证码",
    tryAgain: "重新获取",
    codeLogin: "验证码登录",
    codePlaceholder: "请输入验证码",
    accountPlaceholder: "请输入您的用户名/邮箱/手机号",
    enterPassword: "请输入密码",
    accountForPhone: "请输入手机号",
    enterCorrectPhone: "请输入正确手机号",
    slideMessage: "向右滑动",
    publicKeyError: '获取公钥失败，请刷新后尝试！',
    domainLogin:"域账号登录",
    domainAccount:"域账号",
    domainTxt:"请输入您的域账号"
  },
  // 忘记密码
  getBackPassword: {
    validationTitle: "验证身份",
    getBackPhone: "手机找回",
    formTopTitlePhone: "手机发送验证，确认身份！",
    getBackEmail: "邮箱找回",
    formTopTitleEmail: "邮箱发送验证，确认身份！",
    phoneVerification: "手机验证",
    enterPhone: "请输入手机号",
    NotSMS: "若未收到，请检查拦截的短信或重发验证码。",
    enterCode: "输入验证码",
    setPassword: "设置密码",
    fillPassword: "填写新密码，更安全的使用平台…",
    setNewPassword: "设置新密码",
    enterNewPassword: "输入新密码",
    confirmNewPassword: "确认新密码",
    reenterNewPassword: "请再次输入新密码",
    passwordSettingFinished: "完成设置密码！",
    logInAgain: "完成修改密码，请在平台重新登录！",
    inconsistent: "两次输入密码不一致!",
    emailVerification: "邮箱验证",
    enterEmail: "请输入邮箱",
    NotEmails: "输入发送到“邮箱地址“的验证码。若未收到，请查看垃圾邮件或重发验证码。若未收到，请查看垃圾箱或重发验证码。",
    cannotEmpty: "邮箱不能为空!",
    verificationCodeError: "验证码错误！",
  },
  // 公共
  public: {
    username: "用户名",
    password: "密码",
    operation: "操作",
    detail: "详情",
    addTo: "添加",
    successfullyAddedTo: "添加成功",
    add: "新增",
    successfullyAdded: "新增成功",
    failedToAdd: "新增失败",
    edit: "编辑",
    editCanceled: "已取消编辑",
    successfullyEdited: "编辑成功",
    failedToEdit: "编辑失败",
    delete: "删除",
    batchDeletion: "批量删除",
    deleteSelectedItems: "删除选中项",
    deleteCurrentResults: "删除当前结果",
    successfullyDeleted: "删除成功",
    failedToDelete: "删除失败",
    clear: "清除",
    remove: "移除",
    removedSuccessfully: "移除成功",
    createTime: "创建时间",
    updateTime: "更新时间",
    update: "更新",
    confirm: "确定",
    reset: "重置",
    cancel: "取消",
    goBack: "返回",
    import: "导入",
    export: "导出",
    exportSelectedItems: "导出选中项",
    exportCurrentResults: "导出当前结果",
    batchImport: "批量导入",
    bulkImport: "批量导入",
    bulkExport: "批量导出",
    noData: "暂无数据",
    add: "新增",
    operation: "操作",
    index: "序号",
    details: "详情",
    successfullyDeleted: "删除成功",
    successfullyEdited: "编辑成功",
    successfullyAdded: "新增成功",
    startDate: "开始日期",
    endDate: "结束日期",
    pleaseEnter: "请输入",
    downloadTemplate: "下载模板",
    import: "引进",
    fileSize: "文件最大为",
    fileFormat: "支持xls、xlsx格式",
    batchExport: "批量导出",
    successfullyImported: "导入成功",
    uploadFailed: "上传失败",
    batchAdd: "批量新增",
    batchUpdate: "批量更新",
    binding: "关联",
    batchBinding: "批量关联",
    bindSelectedItems: "关联选中项",
    bindCurrentResults: "关联当前结果",
    boundSuccessfully: "关联成功",
    index: "序号",
    startTime: "开始时间",
    endTime: "结束时间",
    cannotRecovered: "删除后不可恢复，请谨慎操作。",
    downloadImportTemplate: "下载导入模板",
    other: "其他",
    back: "上一步",
    next: "下一步",
    save: "保存",
    to: "至",
    automaticallyGenerated: "自动生成",
    whetherToCancelEditing: "是否取消编辑",
    pageDataWillNotBeSavedPleaseBeCareful: "页面数据不会保存，请谨慎操作",
    pleaseEnter: "请输入",
    noAvailable: "暂无",
    pleaseSelect: "请选择",
    no: "暂无",
    YES: "是",
    NO: "否",
    noData: "暂无数据",
    January: "一月",
    February: "二月",
    March: "三月",
    April: "四月",
    May: "五月",
    June: "六月",
    July: "七月",
    August: "八月",
    September: "九月",
    October: "十月",
    November: "十一月",
    December: "十二月",
    JanuaryNum: "1月",
    FebruaryNum: "2月",
    MarchNum: "3月",
    AprilNum: "4月",
    MayNum: "5月",
    JuneNum: "6月",
    JulyNum: "7月",
    AugustNum: "8月",
    SeptemberNum: "9月",
    OctoberNum: "10月",
    NovemberNum: "11月",
    DecemberNum: "12月",
    organization: "组织机构",
    downloadExcelTemplate: "下载Excel模板",
    downloadTemplate: "下载模板",
    downloadExcelFile: "下载Excel文件",
    uploadFile: "上传文件",
    supportFile: "仅支持xls、xlsx格式",
    template: "模板",
    search: "搜索",
    hasBeenSelected: "已经选择本页{0}项",
    basicInformation: "基本信息",
    gotIt: "知道了",
    download: "下载",
    other: "其他",
    startDate: "开始日期",
    endDate: "结束日期",
    view: "查看",
    editFirstLevelNode: "编辑一级节点",
    addFirstLevelNode: "新增一级节点",
    addNode: "新增节点",
    nodeDetails: "节点详情",
    editNode: "编辑节点",
    superiorNode: "上级节点",
    cannotRecovered: "删除后不可恢复，请谨慎操作。",
    sort: "排序",
    value: "值",
    removeRole: "您确定要移除此角色吗？",
    deleteRole: "您确定要删除此角色吗？",
    addNow: "立即新增",
    Okay: "知道了",
    create: "创建",
    characters: "4～30个字符（1个汉字算2个字符）",
    offline: "离线",
    online: "在线",
    inactivated: "未激活",
    device: "设备",
    gateway: "网关",
    clear: "清除",
    enterUsername: "请输入用户名",
    enterCorrectUserName: "请输入正确的用户名，用户名由字母数字下划线组成，长度为3-45",
    successful: "操作成功",
    failed: "操作失败",
    adjustedSuccessfully: "调整成功",
    failedAdjust: "调整失败",
    enterCorrectName: "请输入正确的姓名",
    characterLimit: "请输入8-16位字符，至少包含数字、大写字母、小写字母、特殊字符中的三种类型",
    characterLength: "字符长度不能超过64位",
    enterEnglishNumbers: "请输入数字，字母，下划线，中划线的组合",
    cannotUseCharacters: "不能使用$字符",
    addressCharacters: "地址需为4-128个字符",
    enterCorrectSocialCreditCode: "请输入正确的社会信用代码",
    enterCorrectPhoneNumber: "请输入正确的手机号",
    serviceBusy: "服务繁忙，请稍后刷新页面后重试!",
    enterCorrectEmail: "请输入正确的邮箱",
    enterEnglishNumbers: "请输入数字，字母，下划线，中划线的组合",
    serviceBusy: "服务繁忙，请稍后刷新页面后重试!",
    hasBeenSelected: "已经选择本页{0}项",
    updatedSuccessfully: "更新成功",
    loadMore: "加载更多",
    noMore: "没有更多了",
    tipTitle:"提示",
    reason:"原因"
  },
  common: {
    selectCurrentPage: "已选本页",
    batchDeletion: "删除选中项",
    order: "序号",
    modifier: "修改人",
    modifyTime: "修改时间",
    action: "操作",
    pleaseEnter: "请输入",
    pleaseChoose: "请选择",
    add: "新增",
    edit: "编辑",
    view: "详情",
    delete: "删除",
    import: "导入",
    cancel: "取消",
    save: "保存",
    export: "导出",
    yes: "是",
    no: "否",
    search: "搜索",
    more: "更多",
    addSearchResult: "添加搜索结果",
    searchContitionName: "搜索条件名称",
    chooseMore: "选择搜索条件",
    saveSearchItems: "保存搜索",
    saveCurrentResult: "保存条件",
    searchContitionWarningTip: "搜索结果最多添加5个",
    searchDelete: {
      title: "您确定要删除该筛选条件组合吗",
      description: "删除组合后可重新添加组合条件",
    },
    operaterSuccess: "操作成功",
    addSuccess: "新增成功",
    editSuccess: "编辑成功",
    deleteSuccess: "删除成功",
    contacts: "联系人",
    telephone: "电话",
    email: "邮箱",
    fax: "传真",
    address: "联系地址",
    description: "描述",
    selectCurrent: "已选本页",
    noRelated: "未查询到相关{0}，可以立即新增",
    term: "项",
    currentPageSelect: "全选本页",
    selectAll: "全选所有",
    empty: "清空",
    deletSelectTerm: "删除选中项",
    emailError: "请输入正确的邮箱地址",
    wordCountLimit: "限{0}字以内",
    createDate: "创建时间",
    updateDate: "更新时间",
    details: "详情",
    status: "状态",
    amount: "数量",
    unit: "单位",
    code: "编号",
    existChildTip: "此数据存在子级，请先删除子级",
    download: "下载",
    uploadImgSizeTip: "上传图片大小不能超过{0}kb",
    uploadImgTypeTip: "请选择{0}格式的图片",
    uploading: "文件上传中",
    fixphoneErrorTip: "请输入正确的电话号码",
    qqErrorTip: "请输入正确的QQ号",
    numberErrorTip: "值类型必须为数值",
    selectLocalImg: "选择本地图片",
    popupDelete: {
      title: "确定要删除吗？",
      description: "删除后不可恢复,请谨慎操作。",
    },
    closeTxt: "关闭",
    column: "表格列",
    button: "按钮",
    tab: "选项卡",
    input: "文本输入框",
    select: "下拉选择框",
    dataPicker: "日期选择框",
    timePicker: "时间选择框",
    switch: "开关按钮",
    checkbox: "选择框",
    radio: "单选按钮",
    textarea: "多行文本输入框",
    tag: "标签",
    searchTo: "至",
    start: "开始",
    end: "结束",
    deleteSuccess: "删除成功",
    issue:"下发",
    success:"成功",
    reset:"重置",
    EDMOrg:"EDM组织",
    greaterThan: "大于等于",
    lessThan: "小于等于",
    successText: "保存成功"
  },
  // 通用表格组件
  generalTable: {
    settingFields: "编辑",
  },
  // 首页
  home: {
    deviceStatus: "设备状态概览",
    totalNumber: "设备总数（台）",
    online: "在线",
    offline: "离线",
    inactivated: "未激活",
    powerOn: "开机",
    downtime: "停机",
    operation: "作业",
    bottleneck: "瓶颈",
    standby: "待机",
    redundancy: "冗余",
    productionEfficiency: "生产效率概览",
    powerOnRate: "开机率",
    peakingRate: "尖峰率",
    bottleneckRate: "瓶颈率",
    operationRate: "作业率",
    redundancyRate: "冗余率",
    energyConsumption: "能源消耗概览",
    powerConsumptionToday: "今日耗电（kWh）",
    applicationCenter: "应用中心",
    notSubscribed: "您尚未订阅应用或尚未给您开通应用使用权限，请联系管理员",
    basicServices: "基础服务",
    alarmStatistics: "报警统计",
    totalAlarms: "报警总数",
    seriousFailure: "严重故障",
    generalFailure: "一般故障",
    nonFailure: "非故障类",
    monthlyTrend: "月趋势",
  },
  // 机构管理
  organization: {
    enterOrganizationInfo: "请输入机构名称、编码",
    addOrganization: "新增机构",
    editOrganization: "编辑机构",
    organizationCode: "机构编码",
    subOrganization: "下属机构",
    organizationName: "机构名称",
    ifThereAreBoundAssets: "是否有关联资产",
    cannotBeDeleted: "含有关联资产的机构不可删除。如需删除，需先解除关联。",
    noRelevantOrganizations: "未查询到相关机构，可以立即新增",
    canBeAdded: "组织机构最多添加10级",
    pleaseBindPersonnel: "请给人员关联组织机构",
    currentOrganization: "当前机构",
    generatedCode: "若暂无内部机构编码可使用自动生成编码",
    deleteOrganization: {
      title: "您确定要删除此机构吗？",
    },
    enterName: "请输入机构名称",
    enterCode: "请输入机构编码",
  },
  // 角色管理
  role: {
    roleDescription: "角色描述",
    enterDescription: "请输入（64字符以内）",
    application: "应用",
    levelMenuLevelMenu: "{0}级菜单",
    buttonPermissions: "按钮权限",
    roleList: "角色列表",
    addRole: "新增角色",
    editRole: "编辑角色",
    roleName: "角色名称",
    dataPermission: "数据权限",
    enterRoleName: "请输入角色名称",
    enterRoleCode: "请输入角色编码",
    enterDataScopeType: "请输入数据权限",
    enterRoleDescription: "请输入角色描述（200字符以内）",
    selectDataPermission: "请选择数据权限",
    addPermission: "新增权限",
    editPermission: "编辑权限",
    noRole: "未查询到相关角色，您可以立即新增",
    selectDimension: "维度选择",
    functionPermissions: "功能权限",
    permissionSuccessfully: "修改角色权限成功",
    roleCode: "角色编码",
    persionNum: "关联人数",
    assignMenu: "分配菜单",
    assignWEB: "WEB授权",
    assignAPP: "APP授权",
    relevanceUser: "关联用户",
    searchPlaceHolder: "请输入角色名称",
    dataScope: "跨部门组织",
    selectDataDataScope: "请输入跨部门的组织",
    roleIssue:"角色下发",
    viewUser:"查看用户",
    viewUserSearch:"请输入用户名、姓名",
    roleAuthorize:"角色授权",
    viewPermission:"查看权限",
    roleView:"角色详情"
  },

  // 用户中心
  userCenter: {
    name: "姓名",
    enterName: "请输入姓名",
    username: "用户名",
    enterUsername: "请输入用户名",
    phoneNumber: "手机号码",
    enterPhoneNumber: "请输入手机号",
    email: "用户邮箱",
    enterEmail: "请输入邮箱",
    mainEnterprise: "主企业",
    changePassword: "修改密码",
    role: "所属角色",
    organization: "所属机构",
    enterprise: "所属企业",
    forgetPassword: "忘记密码",
    mainEnterpriseUpdatedSuccessfully: "更新主企业成功",
    enteringLoginPage: "更新密码成功，即将进入登录页面",
    updatedSuccessfully: "更新成功",
    loginPassword: "登录密码",
    enterLoginPassword: "请输入登录密码",
    newPassword: "新密码",
    enterNewPassword: "请输入新密码",
    pleaseReenterNewPassword: "请再次输入新密码",
    pleaseReenterPassword: "请再次输入密码",
    reenterNewPassword: "重复新密码",
    back: "上一步",
    next: "下一步",
    notSame: "两次输入密码不一致",
    modifyUsername: "修改用户名",
    modifyName: "修改姓名",
    changePhoneNumber: "更换手机号",
    changeEmail: "更换邮箱",
    modifyMainEnterprise: "修改主企业",
    selectMainEnterprise: "选择主企业",
    enterTheCorrectEmailAddress: "请输入正确的邮箱地址",
    getVerificationCode: "获取验证码",
    mobilePhoneVerification: "手机号验证",
    emailVerification: "邮箱验证",
    verificationCode: "验证码",
  },

  // 企业中心
  companyCenter: {
    enterpriseName: "租户名称",
    enterEnterpriseName: "请输入租户名称",
    enterpriseId: "企业ID",
    enterpriseAddress: "企业地址",
    enterEnterpriseAddress: "请输入企业地址",
    unifiedSocialCreditCode: "统一社会信用代码",
    enterUnifiedSocialCreditCode: "请输入统一社会信用代码",
    modifyUnifiedSocialCreditCode: "修改统一社会信用代码",
    modifyEnterpriseName: "修改企业名称",
    modifyEnterpriseAddress: "修改企业地址",
    enterpriseCenter: "企业中心",
    name: "姓名",
    contact: "联系方式",
    role: "角色",
    email: "邮箱",
    phone: "手机",
    addSubadministrator: "添加子管理员",
    enterpriseAdministrator: "企业管理员",
    selectMembers: "选择组织内成员作为该组织的子管理员",
    selectMember: "选择成员",
    searchNameOrPhoneNumber: "搜索姓名或者手机号",
    pleaseSelect: "请选择，可根据用户名，手机号，邮箱模糊搜索组织内成员",
    removeAdministrator: "移除管理员",
    createBusiness:"创建租户"
  },

  energy: {
    addEnergy: "添加能源",
    deleteSuccess: "删除成功！",
    enterEnergyCodeOrOrganization: "请输入能源编码或所属机构",
    energyCode: "能源编码",
    energyCategory: "能源类型",
    organization: "所属机构",
    wantToDeleteEnergyPrice: "您确定要删除此能源价格吗？",
    viewItDeletingIt: "删除后将无法再次查看。",
    energyModificationSucceeded: "能源修改成功",
    energydeleteSucceeded: "能源删除成功",
    okay: "知道了",
    incompleteDefinitionOfElectricityPrice: "电价定义不完整",
    pleaseDefineTheCompletehourElectricityPrice: "请定义完整的24小时电价",
    editEnergy: "编辑能源",
    energyDetails: "能源详情",
    energyAddedSuccessfully: "能源新增成功",
    timePeriodHasBeenSelected: "时间段已被选中",
    theSelectedTimePeriodsOverlap: "所选时间存在交叉",
    pleaseEnterCode: "请输入编码",
    energyUnitPrice: "能源单价",
    pleaseEnterEnergyPrice: "请输入能源价格",
    electricityPrice: "电度电价",
    quoteOrganizationElectricityPrice: "引用机构电价",
    quoteMonthlyElectricityPrice: "引用月份电价",
    clearElectricityPrice: "清除电价",
    clearAll: "清除全部",
    clearThisMonths: "清除本月",
    unitPriceyuan: "单价 (元)",
    period: "时间段",
    unreasonableEnergyPrice: "能源价格不合理",
    canOnlyBeNonnegativeNumber: "能源价格只能是非负数且最多三位小数",
    onlyBeLetterNumberAnd: '编码只能是字母数字"_"和"-"',
    wantToClearAllElectricityPrices: "确定要清空全部电价吗？",
    willBeReeditedPleaseBeCareful: "清空后，所有电价将重新编辑，请谨慎操作。",
    peakHour: "尖时段",
    highHour: "峰时段",
    normalHour: "平时段",
    lowTime: "谷时段",
    pleaseEnterEnergyCode: "请输入能源编码",
    pleaseSelectOrganization: "请选择组织机构",
    pleaseSelectEnergyCategory: "请选择能源类型",
    yuanm: "元/m",
    energyPricesCanOnlyBePositiveNumbersAndHaveUpToThreeDecimalPlaces:
      "能源价格只能是正数且最多三位小数",
    cancel: {
      addTitle: "确定要取消添加能源价格吗？",
      description: "取消后，保存的数据将清空，请谨慎操作。",
    },
    codeCannot: '编码不能只有"_"和"-"组成',
  },
  // 基础管理-班制管理
  classesManage: {
    organizationCode: "机构编码",
    addShift: "新增班制",
    shiftCode: "班制编码",
    enterShiftCode: "请输入班制编码",
    organization: "所属机构",
    shiftDetails: "班制详情",
    shiftCategory: "班制类型",
    shiftName: "班次名称",
    enterShiftName: "请输入班次名称",
    shiftTime: "上下班时间",
    singleShift: "单班制",
    doubleShifts: "双班制",
    threeShifts: "三班制",
    fourShifts: "四班制",
    fiveShifts: "五班制",
    noTimeSelected: "未选择时间",
    timeUnfilled: "未填写时间",
    timeOverlap: "时间重叠",
    shiftNameIsRepeated: "班次名称重复,重复名称为{0}",
    enterTheShiftInfo: "请输入班制编码、班制类型、所属机构搜索班制",
    youCannotViewItAgainAfterDeletingIt: "删除后将无法再次查看。",
    areYouSureYouWantToDeleteThisShift: "您确定要删除此班制吗？",
    startTimeIsTheSameAsEndTime: "开始时间与结束时间相同",
    nextDay: "次日",
    supports: "支持英文、数字、中划线、下划线，共9位，开头和结尾不能为中划线或下划线",
    clockInLater: "上班时间不得晚于下班时间",
    clockInGreater: "上下班时间间隔大于24小时",
    clockInTime: "上班时间",
    clockOutTime: "下班时间",
    failedGetDetails: "获取详情失败",
  },
  //首页相关配置
  home: {
    pageSetting: "界面设置",
  },
  // 企业管理
  enterprise: {
    enterNameCode: "请输入组织名称、纳税识别号、管理员姓名搜索",
    synchronizeEnterprise: "同步租户",
    enterpriseName: "企业名称",
    enterEnterpriseName: "请输入企业名称",
    unifiedSocialCreditCode: "统一社会信用代码",
    enterUnifiedSocialCreditCode: "请输入统一社会信用代码",
    typeOfEnterprise: "租户类型",
    selectTypeOfEnterprise: "请选择企业类型",
    address: "地址",
    enterAddress: "请输入地址",
    administrator: "租户管理员",
    tenantId: "租户ID",
    roleMenu: "分配菜单",
    authorizationStatus: "授权状态",
    phoneNumber: "手机号",
    enterPhoneNumber: "请输入手机号",
    email: "邮箱",
    enterEmail: "请输入邮箱",
    username: "用户名",
    enterUsername: "请输入用户名",
    password: "密码",
    enterPassword: "请输入密码",
    account: "账号",
    enterAccount: "请输入账号",
    synchronizeAllUsers: "同步企业下所有用户",
    notFound: "未搜索到该企业信息",
    queryInterfaceError: "查询接口异常",
    noEnterpriseInfo: "无企业信息，无法进入下一步",
    registerAdmin: "注册管理员",
    usernamePassword: "用户名密码",
    confirmPassword: "确认密码",
    passwordAgain: "请再次输入密码",
    cannotSame: "用户名密码不能相同",
    notMatch: "两次输入密码不一致",
    description: "描述",
    noDescription: "暂无描述",
    appIsNotNamed: "应用未命名",
    rootcloud: "根云应用",
    external: "外部应用",
    basicService: "基础服务",
    backToDetails: "返回详情",
    addedSuccessfully: "增加应用成功",
    applicationAuthorization: "应用授权",
    cancelAuthorization: "取消授权",
    appPermissions: "应用权限",
    wayOfRegister: "注册方式",
    addEnterprise: "新增企业",
    editEnterprise: "编辑企业",
    fillInEnterpriseInfo: "填写企业信息",
    totalEnterprises: "企业总数",
    operator: "运营商",
    completeEnterpriseInfo: "补充企业信息",
    assignePermissions: "还没有分配应用权限，您可以立即增加",
    confirmCancelAuth: "您确定取消该应用的企业授权吗？",
    addAuthTip: "还没有应用可分配权限，您可以前往软件上架增加",
    addApp: "添加应用",
    supplier: "供应商",
    installer: "安装商",
    enterpriseUser: "企业用户",
    syncSuccess: "同步成功",
    existAdminTip: "用户已存在，将添加为该企业的管理员",
    adminName: "管理员姓名",
    searchEnterprise: "搜索企业",
    enterAdminName: "请输入管理员姓名",
    selectAssetCategory: "请选择资产类型",
    assetName: "资产名称",
    assetCode: "资产编码",
    assetCategory: "资产类型",
    status: "状态",
    compoundObject: "复合物实例",
    enterAssetNameAndCode: "请输入资产名称、编码",
    synchronize: "同步",
    socialCreditCode: "纳税识别号"
  },

  //字典管理
  dict: {
    newDict: "新增字典",
    dictName: "字典类型名称",
    dictCode: "字典类型编码",
    searchPlaceHolder: "请输入字典名称、字典编码",
    dictPermission: "类型",
    dictStatus: "字典状态",
    updateTime: "更新时间",
    deleteSuccess: "删除成功",
    delete: {
      title: "您确定要删除此字典吗？",
      description: "删除后不可恢复,请谨慎操作",
    },
  },
  // 编码管理
  code: {
    pleaseEnterCodeOrCodeName: "请输入编码或编码名称",
    preview: "预览",
    confirm: "确 定",
    codeValue: "编码代码",
    addCode: "添加",
    codeName: "编码名称",
    codeExample: "编码值示例",
    bindValue: "绑定值",
    bindField: "绑定字段",
    bindTable: "绑定表",
    codeSegmentType: "码段类型",
    codeSegmentValue: "码段值",
    editable: "可编辑",
    selfGrowth: "自增长",
    length: "长度",
    format: "格式化",
    autoZeroFill: "自动补零",
  },
  dictInfo: {
    dictName: "字典类型名称",
    dictCode: "字典类型编码",
    type: "类型",
    dictStatus: "启用状态",
    description: "备注",
    pleaseEnterDictName: "请输入字典类型名称",
    dictCode: "字典类型编码",
    pleaseEnterDictCodee: "请输入字典类型编码",
    type: "类型",
    pleaseChooseType: "请选择类型",
    dictStatus: "启用状态",
    pleaseChooseDictStatus: "请选择启用状态",
    description: "备注",
    pleaseEnterDescription: "请输入备注",

    dictList: "字典项列表",
    addDict: "新增字典项",
    addDialogTitle: "新增字典",
    editDialogTitle: "修改字典",
    dictItemInfo: {
      dictLabel: "字典项名称",
      dictValue: "字典项代码",
      sort: "排序号",
      systemDefault: "是否系统",
      description: "字典描述",
      pleaseEnterDictName: "请输入字典类型名称",
      pleaseEnterDictCode: "请输入字典类型编码",
      pleaseEnterSort: "请输入排序号",
      PleaseEnterDescription: "请输入字典描述",
    },
    dictViewDetail: "字典详情",
    dictView: {
      dictName: "字典类型名称:",
      dictCode: "字典类型编码:",
      type: "类型:",
      dictStatus: "启用状态:",
      description: "备注:",
    },
  },
  menu: {
    addMenu: "添加菜单",
    menuName: "菜单名称",
    menuType: "菜单类型",
  },
  //用户管理
  user: {
    leftTitle: "组织结构",
    rightTitle: "用户列表",
    displayName: "姓名",
    cardNum:"工号",
    userName: "用户名",
    cellphone: "手机号",
    isEffect: "是否有效",
    sort:"排序",
    isLock: "锁定状态",
    editUser: "编辑用户",
    createUser: "创建用户",
    details: "详情",
    org: "所属机构",
    role: "角色",
    email: "邮箱",
    addClass: "新增分类",
    editClass: "编辑分类",
    searchPlaceHolder: "请输入用户名、姓名、手机号或邮箱",
    addFirstLevelNode: "新增分类",
    remarks: "备注",
    type: "类型",
    assginSuccess: "分配成功",
    assignRoles: "分配角色",
    delete: {
      title: "您确定要删除此设备分类吗？",
      description: "删除后将无法查看此设备分类",
    },
    assignRole: {
      assignRole: "分配角色",
      selectRole: "角色名称",
    },
    resetPassword: "重置密码",
    pleaseEnterSort:"请输入排序号",
    createUser:"创建用户",
    synchroUser:"同步用户",
    belongOrg:"所属组织",
    sex:"性别",
    stateValue:"人员状态",
    updateDate:"更新日期",
    updateUserNum:"更新用户数",
    failedUserNum:"失败用户数",
    saveUserNum:"新增用户数",
    viewSynchroUser:"详见",
    failSynchro:"同步失败"
  },
  // Excel导入配置
  excelConfiguration: {
    dictionaryEncode: "字典编码",
    serialNumber: "序号",
    englishTableName: "英文表名",
    tableName: "表名称",
    dataSheet: "请选择数据表",
    code: "编码",
    name: "名称",
    fieldName: "字段名称",
    datasource: "数据源",
    searchPlaceHolder: "请输入名称、编码",
    addFile: "添加文件",
    configurationMethod: "配置方式",
    controllingThingsWay: "事物控制方式",
    userDefinedProcessingClass: "用户自定义处理类",
    saveData: "保存",
    initializeSheet: "初始化sheet页",
    sheetName: "sheet页名称",
    sheetTableName: "表名称",
    lineNumber: "标题行数",
    updateStatus: "是否更新",
    propertySetting: "属性设置",
    automaticMatching: "自动匹配",
    initializeColumn: "初始化列",
    titleBar: "列标题",
    isItRequired: "字段类型",
    fieldTitle: "字段标题",
    isUnique: "是否唯一",
    charLength: "字段长度",
    isRequired: "是否必填",
    inputType: "输入类型",
    defaultValue: "默认值",
    virtualColumn: "是否虚拟列",
    dataConversionMethod: "数据转换方式",
    selectFile: "选择文件",
    downloadTemplate: "下载模版",
    import: "导入",
    excelTemplate: "Excel",
    excelImport: "Excel导入",
  },
  // 操作日志
  logs: {
    searchSelectDefault: "",
    searchModulePlaceholder: "请输入系统模块",
    searchOperatorPlaceholder: "请选择操作人员",
    searchInputLoginAddress: "请输入登录IP",
    searchInputUserName: "请输入用户名称",
    searchInputTaskName: "请输入任务名称",
    searchInputHistoryLog: "请选择历史日志",
    searchBtnConfirmText: "查询",
    searchBtnResetText: "重置",
    searchBtnSeniorText: "高级查询",
    searchBtnNormalText: "普通查询",
    searchLabelHistoryList: "历史日志",
    searchLabelStartEndTime: "开始/结束时间",
    searchInputStartTime: "开始时间",
    searchInputEndTime: "结束时间",
    searchInputTimeContact: "至",
    searchLabelType: "类型",
    systemModule: "系统模块",
    operationType: "操作类型",
    dialogOperationMsg: "操作信息",
    operationDialogApiTitle: "接口信息",
    requestMode: "请求方式",
    operator: "操作人员",
    host: "主机",
    status: "状态",
    logInformation: "日志信息",
    timeConsuming: "耗时(毫秒)",
    operationDate: "操作日期",
    operate: "操作",
    details: "详情",
    loginLog: "登录日志",
    operateLog: "操作日志",
    exportLog: "导出日志",
    userName: "用户名",
    loginIp: "登录IP",
    loginMethod: "登录方式",
    loginStatus: "操作状态",
    browser: "浏览器",
    operateSystem: "操作系统",
    loginType: "操作类型",
    loginTime: "登录时间",
    executeStatus: "执行状态",
    taskTitle: "任务标题",
    createTime: "创建时间",
  },
  dataPermission: {
    source: "资源",
  },
  calcUnit: {
    title: "计量单位",
    code: "计量单位编码",
    name: "计量单位名称",
    type: "计量单位类型",
    searchPlaceholder: "请输入计量单位编码、名称",
    addCalcUnit: "新增计量单位",
    editCalcUnit: "编辑计量单位",
    noRelated: "未查询到相关计量单位，可以立即新增",
  },
  equipManage: {
    order: "序号",
    title: "设备台账",
    code: "编码",
    name: "名称",
    searchPlaceHolder: "请输入设备编码、名称、型号",
    equipmentList: "设备列表",
    equipmentCode: "设备编码",
    equipmentName: "设备名称",
    equipmentClass: "设备分类",
    specification: "规格型号",
    equipmentBrand: "品牌",
    equipmentStatus: "设备状态",
    belongDepartment: "所属部门",
    belongLocation: "所属位置",
    belongArea: "所在区域",
    useDepartment: "维护部门",
    productLine: "区域位置",
    factoryCode: "出厂编号",
    factoryDate: "出厂日期",
    supplier: "供应商",
    unit: "单位",
    madeDept: "生产厂家",
    stationCode: "工位标识",
    equipmentSource: "设备来源",
    ABCMark: "ABC标识",
    typeChange: "异动类型",
    useDate: "使用日期",
    isFixedAssets: "是否转固",
    fixed: "转固",
    unFixed: "未转固",
    toFixedAssetsDate: "转固日期",
    assetsCode: "资产编号",
    assetsOriginalValue: "资产原值",
    currency: "币别",
    expectedServiceLife: "预计使用期限(月)",
    expectedRetirementDate: "预计报废日期",
    periodTo: "保修期至",
    actualServiceLife: "实际使用期限(月)",
    IOTExample: "IoT实例",
    equipmentId: "设备识别码",
    superBom: "超级BOM",
    newEquip: "新增台账",
    otherInfo: "其他信息",
    assetsInfo: "资产信息",
    basicInfo: "基础信息",
    contant: "联系方式",
    equipmentUse: "设备用途",
    maintenanceOfficer: "维修负责人",
    matAttributes: "配套属性",
    timeAttributes: "时间属性",
    keyEquitment: "是否关键设备",
    devEquitment: "是否关键研发设备",
    measureEquitment: "是否测量设备",
    delete: {
      title: "您确定要删除此设备吗？",
      description: "删除后将无法查看此类型。",
    },
    isIotEquip: "是否IoT设备",
    example: "物实例",
    model: "物模型",
  },
  supplier: {
    title: "供应商管理",
    code: "供应商编码",
    name: "供应商名称",
    type: "供应商类型",
    short: "供应商简称",
    supplier: "供应商",
    searchPlaceholder: "请输入供应商编码、名称",
    addSupplier: "新增供应商",
    editSupplier: "编辑供应商",
  },
  maintenanceStrategy: {
    nameLimit: "策略名称长度不超过64个字",
    codeLimit: "策略编码长度不超过32个字",
    saveSuccess: "保存成功",
    toolFile: "文档与工具",
    triggerSettings: "保养触发设置",
    addConditionGroup: "新增条件组",
    fileSearch: "请输入文档名称、编码",
    condition: "触发条件",
    copyCondition: "复制条件",
    judge: "判断条件",
    equipBom: "结构下设备",
    triggerParmas: "触发参数",
    addEquip: "新增设备",
    editEquip: "编辑设备",
    addStrategy: "新增策略",
    editStrategy: "编辑策略",
    strategyDetails: "策略详情",
    title: "保养策略",
    baseInfo: "基础信息",
    strategyCode: "策略编码",
    strategyName: "策略名称",
    strategyType: "策略类型",
    maintenanceType: "保养类型",
    benchmark: "保养基准",
    Xbenchmark: "巡检基准",
    operationMethods: "操作要领/方法",
    maintenanceLevel: "保养级别",
    executeType: "策略执行类型",
    numericalValue: "数值",
    operatingCondition: "作业后状态",
    mainOrder: "维修工单",
    effectiveDate: "生效日期",
    expireDate: "失效日期",
    invalidDate: "失效日期",
    fillInTheValue: "是否填写数值",
    identification: "分组标识",
    leadTime: "提前期(天)",
    maintenanceNum: "保养数值",
    numericalString: "数值名称",
    numericalUnit: "数值单位",
    upperLimitValue: "上限值",
    lowerLimitValue: "下限值",
    standardValue: "标准值",
    relatedBOMEquipment: "关联BOM及设备",
    relatedBom: "关联BOM",
    addNumber: "新增数值",
    intendedDate: "计划执行日期",
    scheduledStartDate: "创建日期",
    latestExecutionDate: "最晚执行日期",
    lastInspectionTime: "上次巡检时间",
    LastAssignmentTime: "上次作业时间",
    standardWorkingHours: "标准执行工时(分钟)",
    shutdownExecution: "是否停机执行",
    continuousOperation: "是否连续作业",
    triggerConditions: "触发条件",
    allowedInAdvance: "是否允许提前开展",
    schedulingGroupMark: "排程分组标记",
    groupMark: "分组标记",
    degreeOfDifficulty: "难易程度",
    guidanceDocument: "指导文档",
    triggerConditionType: "触发条件类型",
    effectiveDateError: "生效日期应小于开始日期",
    cycle: "周期循环触发",
    triggerOnce: "触发一次",
    each: "每",
    iotModelName: "IoT物模型名称",
    startDate: "开始日期",
    endDate: "结束日期",
    params: "参数",
    addParams: "添加参数",
    params0: "报警阈值测点",
    params1: "实时工况测点",
    standardCycle: "标准周期",
    IotRule: "IoT触发计算规则",
    iotAlarmParams: "IoT触发参数名称",
    alarmInfo: "报警信息",
    dateLimit: "日期范围",
    iotParamsAndLogic: "IoT参数及逻辑",
    symbolOptions: {
      greaterThan: ">（大于）",
      lessThan: "<（小于）",
      greaterThanOrEqualTo: ">=（大于等于）",
      lessThanOrEqualTo: "<=（小于等于）",
      beEqualTo: "==（等于）",
      notEqualTo: "!=（不等于）",
    },
    valueOptions: {
      value: "值",
      parameter: "参数",
    },
    changeRecord: "变更记录",
    useTools: "使用工具",
    deleteTips: "是否删除该策略？",
    toolCorrelationError: "使用工具关联失败",
    toolCode: "工具编号",
    toolName: "工具名称",
    toolModel: "工具型号",
    specifications: "规格型号",
    toolType: "工具分类",
    quantity: "工具数量",
    toolUnit: "工具单位",
    addTool: "新增工具",
    editTool: "编辑工具",
    selectedBOMAndEquip: "关联结构及设备",
    deleteRelatedTips: "是否删除该关联结构？",
    selectedBOM: "BOM名称",
    selectedStructure: "结构名称",
    selectedEquipment: "设备名称",
    relatedWarning: "此结构未关联设备，请关联设备或重新选择结构！",
    triggerType: "触发类型",
    maintainTriggerType: "触发类型",
    lOTModel: "LOT模型",
    addMaintainValue: "新增数值",
    editMaintainValue: "编辑数值",
    reminderSetting: "触发方式",
    searchPlaceHolder: "请输入策略名称或编码",
    fileName: "文件名称",
    fileCode: "文件编码",
    delete: {
      title: "您确定要删除此保养策略吗？",
      description: "删除后将无法查看此保养策略",
    },
    numPass: "数值名称重复",
    bomNoEquip: "{0}下没有设备",
    maintainClass: "保养分类",
  },
  org: {
    searchPlaceHolder: "请输入部门名称、部门编码、简称",
    orgName: "部门名称",
    orgCode: "部门编码",
    orgShortName: "部门简称",
    parentOrg:"上级部门",
    isEffect:"是否有效",
    address:"地点",
    sort:"排序",
    editOrg:"编辑部门",
    createOrg:"创建部门",
    details:"详情",
    remarks:"描述",
    pleaseEnterContent:"请输入内容",
    rightTitle: "组织管理",
    pleaseEnterSort: "请输入排序号",
    parentOrg:"上级部门",
    isEffect:"是否有效",
    address:"地点",
    sort:"排序",
    editOrg:"编辑部门",
    createOrg:"创建部门",
    details:"详情",
    remarks:"描述",
    deleteTitle:"确定要删除组织{0}吗?",
    deleteText:"删除后该组织后将无法使用"
  },
  orgManage:{
    orgCode:"组织编码",
    orgName:"组织名称",
    orgShortName:"组织简称",
    orgType:"组织类型",
    orgManager:"组织管理员",
    searchPlaceHolder:"请输入组织编码、组织名称、简称",
    createOrg:"创建组织",
    parentOrg:"上级组织",
    parentNull:"上级组织不能为空",
    organization:"组织",
    enterRemark:"请输入备注（100字以内）",
    orgDetails:"组织详情",
    orgEdit:"编辑组织"
  },
  depart:{
    synchroDepart:"同步部门"
  },
  parameterTemplate: {
    belongModule: "所属模块",
    belongModuleName: "所属模块名称",
    paramsCode: "参数编码",
    paramsName: "参数名称",
    paramsType: "参数类型",
    paramsMapping: "参数值映射",
    addTemplate: "新增模板",
    editTemplate: "编辑模板",
    templateDetail: "模板详情",
    stringType: "文本型",
    numberType: "数值型",
    switchType: "开关型",
    singleType: "单选型",
    multipleType: "多选型",
    paramsCodeRepeat: "参数编码重复",
    searchPlaceholder: "请输入所属模块编码或者名称",
    selectValue: "选择值",
    displayValue: "展示值",
    paramsKeyValue: "参数键值",
    defaultValueNoExist: "默认值在参数键值对中不存在",
    chooseConfigItem: "选择配置项",
    configItem: "配置项",
    chooseTenant: "选择租户",
    pleaseChooseConfigItem: "请选择参数配置项",
    pleaseChooseTenant: "请选择租户",
    issueSuccess: "下发成功"
  }
};
